"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HISTORY_SNAPSHOT_ID_TYPE = 'number';
var UniqueHistorySnapshot = /** @class */ (function () {
    function UniqueHistorySnapshot(id, snapshot) {
        this.id = id;
        this.$mutation = snapshot.mutation;
        this.$stateData = snapshot.stateData;
    }
    Object.defineProperty(UniqueHistorySnapshot.prototype, "mutation", {
        get: function () {
            return this.$mutation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UniqueHistorySnapshot.prototype, "stateData", {
        get: function () {
            return typeof this.$stateData === 'object'
                ? Array.isArray(this.$stateData)
                    ? __spreadArrays(this.$stateData) : __assign({}, this.$stateData)
                : this.$stateData;
        },
        enumerable: true,
        configurable: true
    });
    UniqueHistorySnapshot.prototype.toSnapshot = function () {
        return { mutation: this.$mutation, stateData: this.$stateData };
    };
    return UniqueHistorySnapshot;
}());
exports.UniqueHistorySnapshot = UniqueHistorySnapshot;
